<template>
  <v-container class="display-value">
    <v-row
      class="inner"
      align="center"
      :justify="isSpaceBetween ? 'space-between' : 'start'"
    >
      <v-col :cols="isSpaceBetween ? 'auto' : 12" class="py-0 title-container">
        <span :class="{ 'font-weight-medium': clientBold }">{{ title }}</span>
        <span v-if="note" class="caption">{{ note }}</span>
      </v-col>
      <v-col :cols="isSpaceBetween ? 'auto' : 12" class="py-0">
        <div class="value"><slot></slot></div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
  import { Component, Vue, Prop } from 'vue-property-decorator';

  @Component
  export default class DisplayValue extends Vue {
    @Prop({ required: true }) title: string;
    @Prop({ default: false }) spaceBetween: boolean;
    @Prop({ default: true }) clientBold: boolean;
    @Prop() note?: string;

    mounted() {}

    get isSpaceBetween() {
      return this.spaceBetween !== false;
    }
  }
</script>

<style scoped>
  .display-value {
    margin: 8px 0;
    padding: 0;

    .title-container {
      @apply tw-flex tw-flex-col;

      .caption {
        @apply tw-text-sm tw-text-gray-500;
        line-height: 1em;
      }
    }
  }
</style>
